import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { AbstractWidgetComponent, HttpService, ServiceResponse, WidgetScale, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { ActionTabletContext } from '../model/action-tablet-context';
import { Station } from 'src/tmc-yard/client/model/station';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CAvailableMovementOrders, CMovementOrder } from '../model/action-tablet.model';

@Component({
  selector: 'app-station-tablet',
  templateUrl: './action-tablet.component.html',
  styleUrls: ['./action-tablet.component.scss']
})
export class ActionTabletComponent extends AbstractWidgetComponent implements OnDestroy {

  private initialized = false;

  private tmcContextServiceUpdateSubscription: Subscription = null;

  private currentlyActiveStationChangedSubscription: Subscription = null;

  enableStationSelectionHeader = false;

  actionTabletContext = new ActionTabletContext();

  selectedStation: Station = null;

  waitingMovementOrders = new Array<CMovementOrder>();

  refreshEnabled = true;
  refreshInterval = null;
  refreshTimer: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private httpService: HttpService
  ) {
    super();

    // Auf Stationsauswahl im Tablet Header reagieren.
    this.currentlyActiveStationChangedSubscription = this.actionTabletContext.currentlyActiveStationChanged.subscribe(stationId => {
      this.selectedStation = this.tmcContextService.findStationById(stationId);
      this.loadWaitingMovementOrders();
    });

    // Moeglich, dass die Stations im Context noch nicht geladen sind, aber bereits die Stationsauswahl triggert.
    this.tmcContextServiceUpdateSubscription = this.tmcContextService.updated.subscribe(yardConfig => {
      if (this.initialized === false && yardConfig != null) {
        this.initialized = true;
        this.checkAndApplySelectedStation();
        this.actionTabletContext.contextReady.next();
      }
    });
  }

  ngOnDestroy() {
    this.currentlyActiveStationChangedSubscription.unsubscribe();
    this.tmcContextServiceUpdateSubscription.unsubscribe();
    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }


  onSetElementAndContext() {
    this.actionTabletContext.widgetIdentifier = this.widgetIdentifier;

    this.refreshEnabled = this.widgetReference.data?.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }
    this.registerRefreshTimer();
  }

  onContextChange(contextChange: ContextChange) {
  }

  getScale(): WidgetScale {
    return WidgetScale.double;
  }


  private registerRefreshTimer() {

      if (this.refreshTimer) {
        this.refreshTimer.unsubscribe();
      }

      if (environment.autoreload && this.refreshEnabled) {
        this.refreshTimer = interval(this.refreshInterval).subscribe(n => {
          this.loadWaitingMovementOrders();
        });
      }
    }

  private checkAndApplySelectedStation() {
    const stationIdentifier = this.activatedRoute.snapshot.queryParamMap.get('stationIdentifier');
        if (stationIdentifier != null) {
          this.enableStationSelectionHeader = false;
          this.selectedStation = this.tmcContextService.findStationByIdentifier(stationIdentifier);
          this.actionTabletContext.currentlyActiveStation = this.selectedStation?.id;
        } else {
          this.enableStationSelectionHeader = true;
        }
  }

  public endSuspension() {
    if (this.selectedStation == null) {
        return;
    }
    this.httpService.postWithContext<ServiceResponse>(environment.actionTabletEndpoint + '/end-station-suspension', { id: this.selectedStation.id })
      .subscribe(() => {
        this.tmcContextService.forceRefreshOfStationUsages();
      });
  }

  public startSuspension() {
    if (this.selectedStation == null) {
        return;
    }
    this.httpService.postWithContext<ServiceResponse>(environment.actionTabletEndpoint + '/suspend-station', { id: this.selectedStation.id })
      .subscribe(() => {
        this.tmcContextService.forceRefreshOfStationUsages();
      });
  }

  private loadWaitingMovementOrders() {
      if (this.selectedStation == null) {
        return;
      }
      this.httpService.postWithContext<CAvailableMovementOrders>(environment.actionTabletEndpoint + '/load-movement-orders-for-station', { id: this.selectedStation.id}).subscribe(result => {
        const loadedMovementOrders = new Array<CMovementOrder>();
        result.movementOrders.forEach(movementOrder => loadedMovementOrders.push(new CMovementOrder(movementOrder)));
        this.waitingMovementOrders = loadedMovementOrders;
      });
  }


  getStyle(): WidgetStyle {
      return WidgetStyle.transparent;
  }

}
